import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { Container, Button, Typography, Box } from '@mui/material';
import { Navigate } from 'react-router-dom';
import { getTenantConfig } from './theme/tenantConfigs';

const Login: React.FC = () => {
  const { loginWithRedirect, isAuthenticated, isLoading } = useAuth0();
  const tenant = getTenantConfig();

  // If still loading, don't redirect yet
  if (isLoading) {
    return null;
  }

  // If authenticated, redirect to home
  if (isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return (
    <Container
      maxWidth="sm"
      sx={{
        minHeight: '100vh',
        background: tenant.gradient,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      <img
        src={tenant.logo}
        alt="Tenant Logo"
        style={{ width: 250, marginBottom: 16 }}
      />

      <Typography
        variant="body1"
        gutterBottom
        sx={{ color: '#fff' }}
      >
        
      </Typography>

      <Box mt={4}>
        <Button
          variant="contained"
          sx={{
            backgroundColor: '#fff',
            color: tenant.primaryColor,
            '&:hover': {
              backgroundColor: '#f8f9fa'
            }
          }}
          onClick={() => loginWithRedirect()}
        >
          Log In
        </Button>
      </Box>
    </Container>
  );
};

export default Login;